import { produce } from 'immer'
import { ActivitySummaryRow } from '../../../typings'
import type { State } from '../../typings'

export const updateActivityProducer = produce<State, [ActivitySummaryRow]>(
  (draft, payload) => {
    const rowIndex = draft.tableState.rows.findIndex((x) => x.id === payload.id)
    if (rowIndex !== -1) {
      const row = draft.tableState.rows[rowIndex]
      draft.tableState.rows[rowIndex] = {
        ...row,
        ...payload,
      }
    }
  },
)
